export default __webpack_public_path__ + "static/media/2357.9bdac4cb.png";